import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserAccount } from '../hooks/useUserAccount'
import { IonPage, IonContent, IonSpinner } from '@ionic/react'

interface ProfileGuardProps {
  children: React.ReactNode
}

// This guard must not redirect users without a full name to /complete-profile: Apple app
// review made us remove that check, because it asks Apple users for a name they already
// provided. The full name is optional, and users can use the app without it.
export const ProfileGuard: React.FC<ProfileGuardProps> = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { userAccount, loading, error } = useUserAccount()

  useEffect(() => {
    if (loading) {
      return
    }

    // If there's an error loading user account, don't redirect
    // Let the AppInitializer handle the error display
    if (error) {
      return
    }

    // If no user account found, redirect to home
    if (!userAccount) {
      navigate('/', { replace: true })
      return
    }
  }, [userAccount, loading, error, location.pathname, navigate])

  // Show loading while checking profile
  if (loading) {
    return (
      <IonPage>
        <IonContent className="ion-padding ion-text-center">
          <div className="flex flex-col items-center justify-center h-full">
            <IonSpinner name="crescent" />
            <p className="mt-4">Cargando perfil...</p>
          </div>
        </IonContent>
      </IonPage>
    )
  }

  if (userAccount) {
    return <>{children}</>
  }

  return null
}
